import { d as o, _ as s } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as t, createElementBlock as n, normalizeClass as r, normalizeStyle as l, createElementVNode as c } from "vue";
const a = o("horizontal-n"), i = /* @__PURE__ */ c("path", {
  d: "M977.455 124.121H46.545C21.721 124.121 0 102.4 0 77.576S21.721 31.03 46.545 31.03h930.91c24.824 0 46.545 21.722 46.545 46.546s-21.721 46.545-46.545 46.545zm0 868.849H46.545C21.721 992.97 0 971.248 0 946.424s21.721-46.545 46.545-46.545h930.91c24.824 0 46.545 21.721 46.545 46.545s-21.721 46.546-46.545 46.546zm0-434.425H356.848c-24.824 0-46.545-21.72-46.545-46.545s21.721-46.545 46.545-46.545h620.607c24.824 0 46.545 21.72 46.545 46.545s-21.721 46.545-46.545 46.545z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), p = [
  i
];
function m(e, _, d, f, h, z) {
  return t(), n("svg", {
    class: r(e.classes),
    style: l(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, p, 6);
}
const C = /* @__PURE__ */ s(a, [["render", m]]);
export {
  C as default
};
